import { isEqual } from 'lodash';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import {
  setCategoryFiltersSelectionAction,
  setCategoryPageNrAction,
  setCategoryRefetchFlagAction,
  setCategorySortByAction,
} from 'store/category/slice';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import prepareCategoryFilters from 'utils/family/prepareCategoryFilters';
import { sortAlgToNumber } from 'utils/family/sortAlgMapping';
import parseCategoryPageParamsServer from 'utils/routes/parseCategoryPageParamsServer';
import getCategoryFilters from '../selector/getCategoryFilters';
import getCategoryPageNr from '../selector/getCategoryPageNr';
import getCategorySortBy from '../selector/getCategorySortBy';
import fetchDesignsOperation from './fetchDesignsOperation';
import { filtersFromQueryString } from './setCategoryFiltersSelectionPHPWayOperation';

const setParamsFromQueryStringOperation =
  (queryString: URLSearchParams | any, fetchData = true) =>
  async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentPageNr = getCategoryPageNr(store);
    const currentSortBy = getCategorySortBy(store);
    const currentFilters = getCategoryFilters(store);

    const { pageNr, sortBy } = parseCategoryPageParamsServer(queryString);
    const categoryFiltersFromURL = filtersFromQueryString(queryString);

    if (sortBy && currentSortBy !== sortAlgToNumber(sortBy)) {
      dispatch(setCategorySortByAction(sortAlgToNumber(sortBy)));
    }
    if (pageNr && currentPageNr !== Number(pageNr)) dispatch(setCategoryPageNrAction(Number(pageNr)));
    if (!isEqual(prepareCategoryFilters(currentFilters), prepareCategoryFilters(categoryFiltersFromURL))) {
      dispatch(setCategoryRefetchFlagAction(true));
      dispatch(setCategoryFiltersSelectionAction(categoryFiltersFromURL));
    }
    if (fetchData) {
      await dispatch(fetchDesignsOperation());
      // don't await for fetching prices
      dispatch(fetchPricesOperation());
    }
  };

export default setParamsFromQueryStringOperation;
